export default class Page<I> {
  number = 0
  items: I[] | null = null
  search = ''
}
